import { defineAsyncComponent } from 'vue'
import { tabOutlineLayoutDashboard } from 'quasar-extras-svg-icons/tabler-icons-v3'

import type { FeatureConfig } from 'src/models'

export type {
  DashboardFeatureTwin,
  DashboardTileTwin,
  DashboardEvent,
  DashboardTileAction,
  DashboardTileActionForNotification,
  DashboardTileActionButton,
  TourGuide,
  TourGuideStep,
  TourGuideStepPopup,
  ExtendedBtnProps
} from 'src/components/features/FeatureEditor'

export {
  DashboardTileActionType,
  DashboardTileActionEventType,
  ButtonStyle,
  ActionButtonPosition,
  MenuType
} from 'src/components/features/FeatureEditor'

const featureConfig: FeatureConfig = {
  main: {
    mainComponent: defineAsyncComponent(() => import('./DashboardFeatureMain.vue')),
    fullWidth: true,
    icon: tabOutlineLayoutDashboard,
    label: 'Dashboard'
  }
}

export default featureConfig
